import { Link } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50" aria-labelledby="category-title">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 id="category-title" className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            番剧分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-[480px] mx-auto">
            按类型浏览，快速找到你喜欢的动漫
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.key}
              to={`/category/${cat.key}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl ${
                cat.color === 'primary'
                  ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white'
                  : 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-white'
              } transition-all duration-300`}>
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-foreground-950 transition-colors whitespace-nowrap">
                {cat.label}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}